class EventEmitter {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(listener);
  }
  off(event, listener) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((l) => l !== listener);
  }
  emit(event, data) {
    if (this.events[event]) {
      this.events[event].forEach((listener) => listener(data));
    }
  }
}

class PurpleProduct extends EventEmitter {
  constructor() {
    super();
    this.globalCartItems = [];
    this.initCartState();
    this.initGallery();
    this.initQuantity();
    this.initVariants();
    this.initBuyNow();
    this.initAddToCart();
    this.bindExternalEvents();
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  initCartState() {
    const initialCartStateEl = document.getElementById('initial-cart-state');
    if (initialCartStateEl) {
      try {
        this.globalCartItems = JSON.parse(initialCartStateEl.textContent).items || [];
      } catch (e) {
        console.error('Error parsing cart state', e);
      }
    }
  }

  bindExternalEvents() {
    // Listen to global document cart:updated events (for external compatibility)
    document.documentElement.addEventListener('cart:updated', () => {
      fetch('/cart.js', { cache: 'no-cache' })
        .then(r => r.json())
        .then(cart => {
          this.globalCartItems = cart.items || [];
          this.updateVariant();
        });
    });
  }

  initGallery() {
    this.mainImage = document.getElementById('MainProductImage');
    this.thumbs = document.querySelectorAll('.thumb-btn');
    if (this.thumbs.length > 0) {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          this.thumbs.forEach((t) => t.classList.remove('on'));
          e.currentTarget.classList.add('on');
          if (this.mainImage && e.currentTarget.dataset.imageUrl) {
            this.mainImage.src = e.currentTarget.dataset.imageUrl;
            this.mainImage.srcset = e.currentTarget.dataset.imageUrl;
          }
        });
      });
    }
  }

  initQuantity() {
    this.qtyInput = document.getElementById('qty');
    this.minusBtn = document.querySelector('.qty-btn.minus');
    this.plusBtn = document.querySelector('.qty-btn.plus');

    if (this.minusBtn && this.plusBtn && this.qtyInput) {
      this.minusBtn.addEventListener('click', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        if (val > 1) {
          this.qtyInput.value = val - 1;
          this.checkQtyLimits();
        }
      });
      this.plusBtn.addEventListener('click', () => {
        this.qtyInput.value = (parseInt(this.qtyInput.value) || 1) + 1;
        this.checkQtyLimits();
      });
      this.qtyInput.addEventListener('change', () => this.checkQtyLimits());
    }
  }

  checkQtyLimits() {
    if (!this.qtyInput) return;
    let val = parseInt(this.qtyInput.value) || 0;
    let max = this.qtyInput.hasAttribute('max') ? parseInt(this.qtyInput.getAttribute('max')) : null;

    if (max !== null && max === 0) {
      this.qtyInput.value = 0;
      if (this.plusBtn) this.plusBtn.disabled = true;
      if (this.minusBtn) this.minusBtn.disabled = true;
      return;
    }

    if (val < 1) val = 1;

    const limitMsg = document.querySelector('.stock-limit-message');

    if (max !== null && val >= max) {
      val = max;
      if (this.plusBtn) this.plusBtn.disabled = true;
      if (limitMsg) {
        limitMsg.style.display = 'block';
        limitMsg.classList.add('is-visible');
      }
    } else {
      if (this.plusBtn) this.plusBtn.disabled = false;
      if (limitMsg) {
        limitMsg.style.display = 'none';
        limitMsg.classList.remove('is-visible');
      }
    }

    if (this.minusBtn) {
      this.minusBtn.disabled = (val <= 1);
    }

    this.qtyInput.value = val;
  }

  initVariants() {
    this.variantRadios = document.querySelector('variant-radios');
    const variantsDataEl = document.getElementById('product-variants-data');
    this.variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    
    this.productForm = document.querySelector('product-form');
    this.showInventory = this.productForm ? this.productForm.dataset.showInventory === 'true' : false;
    
    this.hiddenIdInput = document.querySelector('input[name="id"]');
    this.stockStatusEl = document.getElementById('StockStatus');
    this.priceEl = document.getElementById('ProductPrice');
    this.pixPriceEl = document.getElementById('ProductPixPrice');
    this.instPriceEl = document.getElementById('ProductInstallments');
    this.sectionUrl = this.variantRadios ? this.variantRadios.dataset.url : window.location.pathname;

    const options = document.querySelectorAll('.opt input[type="radio"]');
    if (options.length > 0) {
      options.forEach((radio) => {
        radio.addEventListener('change', (e) => {
          const fieldset = e.target.closest('fieldset');
          fieldset.querySelectorAll('label').forEach((l) => l.classList.remove('on'));
          fieldset.querySelector(`label[for="${e.target.id}"]`).classList.add('on');

          const selectedText = fieldset.querySelector('.selected-option-value');
          if (selectedText) selectedText.textContent = e.target.value;

          this.updateVariant();
        });
      });
    }
  }

  updateVariant() {
    if (!this.variantsData.length) return;
    let matchedVariant = null;

    if (this.variantRadios) {
      const selectedOptions = Array.from(document.querySelectorAll('.opt input[type="radio"]:checked')).map((el) => el.value);
      matchedVariant = this.variantsData.find((v) => {
        return v.options.every((opt, index) => opt === selectedOptions[index]);
      });
    } else {
      const currentId = this.hiddenIdInput ? this.hiddenIdInput.value : null;
      matchedVariant = this.variantsData.find(v => v.id == currentId) || this.variantsData[0];
    }

    if (matchedVariant) {
      if (this.hiddenIdInput) this.hiddenIdInput.value = matchedVariant.id;

      if (this.sectionUrl) {
        window.history.replaceState({}, '', `${this.sectionUrl}?variant=${matchedVariant.id}`);
      }

      let cartQty = 0;
      if (typeof this.globalCartItems !== 'undefined') {
        const cartItems = this.globalCartItems.filter(item => item.id == matchedVariant.id);
        cartQty = cartItems.reduce((acc, item) => acc + item.quantity, 0);
      }

      let availableToAdd = null;
      if (matchedVariant.inventory_management === 'shopify' && matchedVariant.inventory_policy === 'deny') {
        availableToAdd = Math.max(0, matchedVariant.inventory_quantity - cartQty);
      }

      if (this.qtyInput) {
        if (availableToAdd !== null) {
          this.qtyInput.setAttribute('max', availableToAdd);
          const maxVal = document.querySelector('.stock-max-val');
          if (maxVal) maxVal.textContent = availableToAdd;
        } else {
          this.qtyInput.removeAttribute('max');
        }
        this.checkQtyLimits();
      }

      this.updateStatusAndButtons(matchedVariant, availableToAdd);
      this.updatePrice(matchedVariant);

      if (matchedVariant.featured_image && this.mainImage) {
        this.mainImage.src = matchedVariant.featured_image.src;
        this.mainImage.srcset = matchedVariant.featured_image.src;
      }
      
      this.emit('variant:updated', matchedVariant);
    } else {
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = 'Indisponível';
      }
      if (this.buyNowBtn) this.buyNowBtn.disabled = true;
    }
  }

  updateStatusAndButtons(matchedVariant, availableToAdd) {
    if (matchedVariant.available) {
      if (this.stockStatusEl) {
        let stockHtml = 'Em estoque';
        if (this.showInventory && matchedVariant.inventory_management === 'shopify' && matchedVariant.inventory_policy === 'deny' && matchedVariant.inventory_quantity > 0) {
          stockHtml += ` <span class="inventory-count">(${matchedVariant.inventory_quantity} disponíveis)</span>`;
        }
        this.stockStatusEl.style.color = 'var(--ok)';
        this.stockStatusEl.innerHTML = stockHtml;
      }

      if (availableToAdd !== null && availableToAdd <= 0) {
        if (this.addToCartBtn) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.style.display = '';
          this.addToCartBtn.textContent = 'Limite no carrinho';
        }
        if (this.buyNowBtn) this.buyNowBtn.disabled = false;
      } else {
        if (this.addToCartBtn) {
          this.addToCartBtn.style.display = '';
          this.addToCartBtn.disabled = false;
          this.addToCartBtn.textContent = 'Adicionar ao carrinho';
        }
        if (this.buyNowBtn) this.buyNowBtn.disabled = false;
      }
    } else {
      if (this.stockStatusEl) {
        this.stockStatusEl.style.color = 'red';
        this.stockStatusEl.innerHTML = 'Esgotou o estoque';
      }

      if (this.addToCartBtn) {
        this.addToCartBtn.style.display = '';
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.textContent = 'Esgotou o estoque';
      }
      if (this.buyNowBtn) this.buyNowBtn.disabled = true;
    }
  }

  updatePrice(matchedVariant) {
    if (this.priceEl && matchedVariant.price) {
      this.priceEl.textContent = this.formatMoney(matchedVariant.price);
      if (this.pixPriceEl) {
        const pixDiscount = parseFloat(this.pixPriceEl.dataset.pixDiscount) || 0;
        const pixText = this.pixPriceEl.dataset.pixText || 'no Pix';

        if (pixDiscount > 0) {
          const multiplier = (100 - pixDiscount) / 100;
          this.pixPriceEl.innerHTML = `${this.formatMoney(matchedVariant.price * multiplier)} ${pixText} (${pixDiscount}% off)`;
          this.pixPriceEl.style.display = 'block';
        } else if (matchedVariant.compare_at_price > matchedVariant.price) {
          const discountAmt = matchedVariant.compare_at_price - matchedVariant.price;
          const discountPct = Math.round((discountAmt * 100) / matchedVariant.compare_at_price);
          this.pixPriceEl.innerHTML = `De <s>${this.formatMoney(matchedVariant.compare_at_price)}</s> (${discountPct}% off)`;
          this.pixPriceEl.style.display = 'block';
        } else {
          this.pixPriceEl.innerHTML = '';
          this.pixPriceEl.style.display = 'none';
        }
      }
      if (this.instPriceEl) {
        const maxInst = parseInt(this.instPriceEl.dataset.max) || 12;
        const minCents = parseInt(this.instPriceEl.dataset.min) || 5000;
        let calcInst = 1;
        for (let i = 1; i <= maxInst; i++) {
          if ((matchedVariant.price / i) >= minCents) {
            calcInst = i;
          }
        }
        this.instPriceEl.textContent = 'ou ' + calcInst + 'x de ' + this.formatMoney(matchedVariant.price / calcInst) + ' sem juros';
      }
    }
  }

  initBuyNow() {
    this.buyNowBtn = document.querySelector('.buy-now-btn');
    if (this.buyNowBtn) {
      this.buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (!this.hiddenIdInput) return;
        const variantId = this.hiddenIdInput.value;
        const qty = this.qtyInput ? parseInt(this.qtyInput.value) || 1 : 1;
        const max = this.qtyInput && this.qtyInput.hasAttribute('max') ? parseInt(this.qtyInput.getAttribute('max')) : null;
        if (!variantId || this.buyNowBtn.disabled) return;

        if (max !== null && max === 0) {
          window.location.href = '/checkout';
        } else {
          window.location.href = `/cart/add?id=${variantId}&quantity=${qty}&return_to=/checkout`;
        }
      });
    }
  }

  initAddToCart() {
    this.addToCartBtn = document.querySelector('.add-to-cart-btn');
    const form = document.querySelector('.product-form form');
    if (form && this.addToCartBtn) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();

        const variantInput = form.querySelector('input[name="id"]');
        const variantId = variantInput ? variantInput.value : null;
        const quantity = this.qtyInput ? parseInt(this.qtyInput.value) || 1 : 1;

        if (!variantId) return;

        const bodyData = { id: variantId, quantity };

        const originalText = this.addToCartBtn.textContent;
        this.addToCartBtn.textContent = 'Adicionando...';
        this.addToCartBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bodyData),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((errorData) => { throw errorData; });
            }
            return response.json();
          })
          .then((data) => {
            this.addToCartBtn.textContent = 'Adicionado! ✓';
            this.emit('product:added', data);

            // Fetch updated cart and dispatch global events
            fetch('/cart.js', { cache: 'no-cache' })
              .then(res => res.json())
              .then(cartData => {
                this.emit('cart:updated', cartData);
                
                document.querySelectorAll('.cartdot').forEach((dot) => {
                  dot.textContent = cartData.item_count;
                });
                
                // Fallback global events for legacy scripts
                document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: { cart: cartData } }));
                document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cartData } }));
              })
              .catch(err => console.error('Error fetching cart state:', err));

            setTimeout(() => {
              if (!this.addToCartBtn.disabled) {
                this.addToCartBtn.textContent = originalText;
              } else {
                this.updateVariant();
              }
            }, 2000);
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            this.addToCartBtn.textContent = error.description || 'Sem estoque';
            this.emit('product:add_error', error);

            if (error.status === 422) {
              this.addToCartBtn.disabled = true;
              if (this.buyNowBtn) this.buyNowBtn.disabled = true;
            } else {
              setTimeout(() => {
                this.addToCartBtn.textContent = originalText;
                this.addToCartBtn.disabled = false;
              }, 3000);
            }
          });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.purpleProduct = new PurpleProduct();
});
